import { Route, Routes } from 'react-router-dom';
// import GalleryPage from './GalleryPage';
import GalleryPage from './GalleryPage';
import ImageViewPage from './ImageView';
import ImageViewPageBeta from './ImageViewBeta';


const ImageViewRouter: React.FC = () => {
  return(
  <Routes>
    <Route path="/" element={<GalleryPage />} /> {/* Gallery Route */}
    <Route path=":imageId" element={<ImageViewPage />} /> {/* Image Viewer Route */}
    <Route path="/beta/:imageId" element={<ImageViewPageBeta />} /> {/* Image Viewer Route */}

  </Routes>
  )
}

export default ImageViewRouter